var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Hello Testing "+_vm._s(_vm.evenNumber))]),_c('vs-button',{on:{"click":function($event){return _vm.methodClick()}}},[_vm._v("Button")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }